import React from "react";
import { useTranslation } from "react-i18next";
import { getStatusMeta } from "./constants";

/**
 * Horizontal stacked progress bar built from a batch's status_counts map,
 * e.g. { allocated: 80, deployed: 12 }. Renders a legend underneath.
 */
const BatchStatusBar = ({ statusCounts = {} }) => {
  const { t } = useTranslation();
  const entries = Object.entries(statusCounts).filter(([, count]) => count > 0);
  const total = entries.reduce((sum, [, count]) => sum + count, 0);

  if (total === 0) {
    return (
      <div className="text-xs text-[#9CA3AF]">
        {t("admin.manufacturing.batchStatusBar.empty")}
      </div>
    );
  }

  return (
    <div>
      <div className="flex h-2.5 w-full overflow-hidden rounded-full bg-[#F3F4F6]">
        {entries.map(([status, count]) => {
          const meta = getStatusMeta(status);
          return (
            <div
              key={status}
              className="h-full"
              style={{
                width: `${(count / total) * 100}%`,
                backgroundColor: meta.color,
              }}
              title={t("admin.manufacturing.batchStatusBar.segmentTitle", {
                label: meta.label,
                count,
              })}
            />
          );
        })}
      </div>

      <div className="mt-3 flex flex-wrap gap-x-4 gap-y-1.5">
        {entries.map(([status, count]) => {
          const meta = getStatusMeta(status);
          return (
            <div key={status} className="flex items-center gap-1.5">
              <span
                className="h-2 w-2 rounded-full"
                style={{ backgroundColor: meta.color }}
              />
              <span className="text-xs text-[#374151]">{meta.label}</span>
              <span className="text-xs font-semibold text-[#111827]">
                {count.toLocaleString()}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default BatchStatusBar;
